import React, { useState } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/sections/HeroSection";
import ServicesSection from "@/components/sections/ServicesSection";
import WhyUsSection from "@/components/sections/WhyUsSection";
import PortfolioSection from "@/components/sections/PortfolioSection";
import ProcessSection from "@/components/sections/ProcessSection";
import RoomsSection from "@/components/sections/RoomsSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import PartnersSection from "@/components/sections/PartnersSection";
import BlogSection from "@/components/sections/BlogSection";
import FAQSection from "@/components/sections/FAQSection";
import CostCalculatorSection from "@/components/sections/CostCalculatorSection";
import Footer from "@/components/Footer";
import ContactDialog from "@/components/ContactDialog";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function HomePage() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <Navigation onContactClick={() => setContactOpen(true)} />
      <main>
        <HeroSection onContactClick={() => setContactOpen(true)} />
        <ServicesSection />
        <WhyUsSection />
        <PortfolioSection />
        <ProcessSection />
        <RoomsSection />
        <TestimonialsSection />
        <PartnersSection />
        <BlogSection />
        <FAQSection />
        <CostCalculatorSection onContactClick={() => setContactOpen(true)} />
      </main>
      <Footer onContactClick={() => setContactOpen(true)} />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
      <WhatsAppButton />
    </>
  );
}
